import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Analytics } from '@vercel/analytics/react';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(error) { return { hasError: true, errorMsg: error?.message || String(error) }; }
  componentDidCatch(error, info) { console.error("App crashed:", error, info); this.setState({ errorMsg: (error?.message || String(error)) + " | " + (info?.componentStack?.split("\n")?.[1] || "") }); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:"100vh", padding:32, fontFamily:"DM Sans,sans-serif", textAlign:"center" }}>
          <div style={{ fontSize:32, marginBottom:16 }}>⚠️</div>
          <div style={{ fontSize:18, fontWeight:700, marginBottom:8, color:"#1a4a3a" }}>Something went wrong</div>
          <div style={{ fontSize:14, color:"#666", marginBottom:24 }}>Please refresh the page to continue.</div>
          <div style={{ fontSize:11, color:"#999", fontFamily:"monospace", background:"#f5f5f5", padding:"8px 12px", borderRadius:6, maxWidth:"100%", wordBreak:"break-all", marginBottom:16 }}>{this.state.errorMsg}</div>
          <button onClick={() => window.location.reload()} style={{ background:"linear-gradient(135deg,#22d3b8,#16a34a)", color:"#fff", border:"none", borderRadius:9, padding:"10px 24px", fontSize:14, fontWeight:700, cursor:"pointer" }}>Refresh Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
      <Analytics />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
